module.exports = __webpack_public_path__ + "img/discover.0dbbeeb8.svg";